import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../Utils/baseQueryWithReauth";

export interface ClearCacheResponse {
  message: string;
  clearedKeys?: string[];
  clearedKey?: string;
  clearedAt: string;
}

export interface ClearAllRedisResponse {
  success: boolean;
}

// Define the cache admin API
export const cacheAdminAPI = createApi({
  reducerPath: "cacheAdmin",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    // Clear all Redis cache
    clearAllRedisCache: builder.mutation<ClearAllRedisResponse, void>({
      query: () => ({
        url: "common/removeAllRedisCacheAtOnce",
        method: "GET"  // Existing API uses GET
      })
    }),

    // Clear Close The Loop cache (memory cache)
    clearCloseTheLoopCache: builder.mutation<{ message: string }, void>({
      query: () => ({
        url: "closetheloop/clear-cache",
        method: "POST"
      })
    }),

    // Generic clear cache by endpoint
    clearCacheByEndpoint: builder.mutation<any, { endpoint: string; method?: "GET" | "POST" }>({
      query: ({ endpoint, method = "POST" }) => ({
        url: endpoint,
        method
      })
    })
  })
});

export const {
  useClearAllRedisCacheMutation,
  useClearCloseTheLoopCacheMutation,
  useClearCacheByEndpointMutation
} = cacheAdminAPI;
